import type { SVGProps } from 'react';
const SvgFileWithLines = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <desc>{'Common File Text Streamline Icon: https://streamlinehq.com'}</desc>
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M22.5 21.75a1.5 1.5 0 0 1-1.5 1.5H3a1.5 1.5 0 0 1-1.5-1.5V2.25A1.5 1.5 0 0 1 3 .75h15.045a1.5 1.5 0 0 1 1.048.426l2.954 2.883a1.5 1.5 0 0 1 .453 1.074ZM6.045 8.25h12M6.045 12.75h12M6.045 17.25h6"
    />
  </svg>
);
export default SvgFileWithLines;
